import { Application } from "../../System/Application/Application";

export function HelloWorld(props) {
    if (props.language === "Fr") {
        return (
            <Application {...props}>
                <div className="hello-world-content">
                    <h1>{props.args.title.Fr}</h1>
                    <p>Ceci est une application simple Bonjour le monde.</p>
                    <p>N'hésitez pas à la personnaliser !</p>
                </div>
            </Application>
        );
    }

    return (
        <Application {...props}>
            <div className="hello-world-content">
                <h1>{props.args.title.En}</h1>
                <p>This is a simple Hello World application.</p>
                <p>Feel free to customize it!</p>
            </div>
        </Application>
    );
}
